import { useEffect, useRef } from 'react';
import { useLanguage } from '../i18n/LanguageContext';

export interface QuizShareNameFieldProps {
  value: string;
  onChange: (value: string) => void;
  autoFocus?: boolean;
  showRequiredHint?: boolean;
}

export default function QuizShareNameField({
  value,
  onChange,
  autoFocus = false,
  showRequiredHint = false,
}: QuizShareNameFieldProps) {
  const { m } = useLanguage();
  const labels = m.share.nameField;
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (autoFocus) {
      inputRef.current?.focus();
    }
  }, [autoFocus]);

  return (
    <label className="quiz-share-name-field">
      <span className="quiz-share-name-label">{labels.label}</span>
      <input
        ref={inputRef}
        type="text"
        className="quiz-share-name-input"
        placeholder={labels.placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        maxLength={24}
        autoComplete="nickname"
        name="quiz-share-display-name"
      />
      {showRequiredHint && !value.trim() && (
        <span className="quiz-share-name-hint">{labels.requiredHint}</span>
      )}
    </label>
  );
}